const ExternalTourProviders = (externalTourProviders: Array<string> = []): Array<string> => {
  return externalTourProviders.map((x) => x);
};

export { ExternalTourProviders };
